import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import {
  BTabs,
  BTab,
  BButton,
  BCol,
  BRow,
  BBadge,
  BCard,
  BCardText,
  BLink,
  BImg,
  BOverlay,
  BCardBody,
  BCardTitle,
  BAlert,
  BCardFooter,
  BSpinner,
} from 'bootstrap-vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('b-tabs', BTabs)
Vue.component('b-spinner', BSpinner)
Vue.component('b-tab', BTab)
Vue.component('b-button', BButton)
Vue.component('b-alert', BAlert)
Vue.component('b-col', BCol)
Vue.component('b-row', BRow)
Vue.component('b-badge', BBadge)
Vue.component('b-card', BCard)
Vue.component('b-card-body', BCardBody)
Vue.component('b-card-text', BCardText)
Vue.component('b-card-title', BCardTitle)
Vue.component('b-card-footer', BCardFooter)
Vue.component('b-link', BLink)
Vue.component('b-img', BImg)
Vue.component('b-overlay', BOverlay)
